import { REVENUE_BASES, type RevenueBasis } from '@servwell/shared';
import { PressedGroup } from '../../ui/PressedGroup';
import { BASIS_WORDS } from './basisWords';

/** The bases as the group's options, named as the page names them. */
const BASIS_OPTIONS = REVENUE_BASES.map((basis) => ({
  value: basis,
  label: BASIS_WORDS[basis].label,
}));

/**
 * The Revenue page's Invoiced | Collected switch (ops insights Phase 2, ticket 07, spec Q2): one
 * choice that changes every number on the page, kept in the address (`?basis=collected`;
 * Invoiced, the default, is never written). Drawn by the same `PressedGroup` as the period
 * presets beside it. The server decides every figure on either basis; this only picks one.
 */
export function BasisSwitch({
  value,
  onChange,
}: {
  value: RevenueBasis;
  onChange: (next: RevenueBasis) => void;
}) {
  return (
    <PressedGroup
      label="Invoiced or collected"
      options={BASIS_OPTIONS}
      value={value}
      onChange={onChange}
    />
  );
}
